import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translation } from './translation/en';
import { caregiver } from './translation/caregiver_en';
import { family } from './translation/family_en';
import { publicApp } from './translation/public_en';

const resources = { en: { translation, caregiver, family, public: publicApp } } as const;

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    resources,
    returnNull: false,
  });
}

export default i18n;
